import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail } from "lucide-react";
import { api, errText } from "../../lib/api";
import { DataTable, Select, money, shortDate, useFilterOptions, useTable } from "./ui";

export default function CustomersPage() {
  const table = useTable("/admin/tables/customers");
  const options = useFilterOptions();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  // Puts the customers currently listed (after search and filters) on the Acumbamail list.
  const addVisible = async () => {
    const emails = (table.rows || []).map((r) => r.email).filter(Boolean);
    if (!emails.length) return;
    setBusy(true); setMsg("");
    try {
      const { data } = await api.post("/admin/newsletter/subscribe-many", { emails });
      setMsg(`${data.added} added to the newsletter${data.failed ? `, ${data.failed} failed` : ""}.`);
    } catch (e) { setMsg(errText(e)); }
    finally { setBusy(false); }
  };

  const columns = [
    { key: "email", label: "Customer", sortable: true, render: (r) => (
      <Link to={`/admin/customers/${encodeURIComponent(r.email)}`} className="underline decoration-brass underline-offset-2" data-testid={`customer-link-${r.email}`}>
        {r.email}
      </Link>
    ) },
    { key: "country", label: "Country" },
    { key: "orders", label: "Orders", sortable: true, render: (r) => <span className="tabular">{r.orders}</span> },
    { key: "ltv_mad", label: "Lifetime value", sortable: true, render: (r) => <span className="tabular whitespace-nowrap">{money(r.ltv_mad)} MAD</span> },
    { key: "aov_mad", label: "Average order", sortable: true, render: (r) => <span className="tabular whitespace-nowrap">{money(r.aov_mad)} MAD</span> },
    { key: "plans", label: "Plans", render: (r) => <span className="tabular">{r.plans}</span> },
    { key: "first_order", label: "First order", render: (r) => shortDate((r.first_order || "").slice(0, 10)) },
    { key: "last_order", label: "Last order", sortable: true, render: (r) => shortDate((r.last_order || "").slice(0, 10)) },
  ];

  const filters = (
    <Select testid="customers-filter-country" placeholder="Any country" value={table.params.country}
            onChange={(v) => table.set({ country: v })} options={options.countries || []} />
  );

  const right = (
    <div className="flex items-center gap-2">
      {msg ? <span className="text-[11px] text-muted" data-testid="customers-newsletter-message">{msg}</span> : null}
      <button className="btn-ghost text-[11px] inline-flex items-center gap-1.5" disabled={busy}
              onClick={addVisible} data-testid="customers-add-to-newsletter">
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Mail size={12} />}
        Add these to the newsletter
      </button>
    </div>
  );

  return <DataTable table={table} columns={columns} testid="customers-table" name="customers" filters={filters}
                    right={right} rowId={(r) => r.email} searchPlaceholder="Email…" empty="No customer matches that." />;
}
